import { presetToRange } from '../components/common/DateRangeFilter';

// Same key the Gemini Enterprise DateRangeProvider persists to, so the Axon
// chat panel (which lives outside that provider) sees the page's real window.
const STORAGE_KEY = 'gemini_agents_date_range';

const PRESET_META = {
  '1d': { days: 1, label: 'last 24 hours' },
  '7d': { days: 7, label: 'last 7 days' },
  '30d': { days: 30, label: 'last 30 days' },
  '90d': { days: 90, label: 'last 90 days' },
};

/**
 * The Gemini Enterprise pages' active date window, for the AI chat context.
 *
 * Returns { days?, label, start, end } matching what the page queries with:
 * the stored preset (recomputed fresh, like the provider does), a stored
 * custom range, or the provider's 30d default when nothing is stored yet.
 */
export function geminiTimeRangeForContext() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      const { key, params } = JSON.parse(raw);
      if (key && PRESET_META[key]) {
        const range = presetToRange(key);
        return { ...PRESET_META[key], start: range.start_time, end: range.end_time };
      }
      if (key === 'custom' && params?.start_time && params?.end_time) {
        return { label: 'selected period', start: params.start_time, end: params.end_time };
      }
    }
  } catch { /* corrupt storage — fall through to the default */ }
  const range = presetToRange('30d');
  return { ...PRESET_META['30d'], start: range.start_time, end: range.end_time };
}

export default geminiTimeRangeForContext;
